import { useState, useEffect } from "react";

export default function ReportOverview() {
  const [reports, setReports] = useState([]);
  const [groups, setGroups] = useState([]);
  const [reportGroups, setReportGroups] = useState([]);
  const [reportMembers, setReportMembers] = useState([]);
  const [reportMembersMap, setReportMembersMap] = useState([]);
  const minutesLabel = (m) => {
    if (!m || m === 0) return "—";
    if (m % 60 === 0) {
      const hours = m / 60;
      return hours === 1 ? "1 hr" : `${hours} hrs`;
    }
    const hours = Math.floor(m / 60);
    const mins = m % 60;
    if (hours === 0) return `${mins} min`;
    return `${hours} hr${hours > 1 ? "s" : ""} ${mins} min`;
  };

  useEffect(() => {
    fetch(process.env.REACT_APP_BACKEND_URL+"/button_report_definitions")
      .then(res => res.json())
      .then(setReports);
    fetch(process.env.REACT_APP_BACKEND_URL+"/report_groups")
      .then(res => res.json())
      .then(setGroups);
    fetch(process.env.REACT_APP_BACKEND_URL+"/report_report_groups")
      .then(res => res.json())
      .then(setReportGroups);
    fetch(process.env.REACT_APP_BACKEND_URL+"/report_members")
      .then(res => res.json())
      .then(setReportMembers);
    fetch(process.env.REACT_APP_BACKEND_URL+"/report_groups_members")
      .then(res => res.json())
      .then(setReportMembersMap);
  }, []);

  const getReportGroupIds = (reportId) => {
    const linkedGroups = reportGroups
          .filter(rg => rg.report_id === reportId)
          .map(rg => {return rg.report_group_id});
    return linkedGroups;
  }

  const getReportMembers = (reportId) => {
    const reportGroupIds = getReportGroupIds(reportId);

    const memberIds = new Set();
    reportGroupIds.forEach(gid => {
      reportMembersMap
        .filter(rgm => rgm.group_id === gid)
        .forEach(rgm => memberIds.add(rgm.member_id));
    });
    const memberNames = Array.from(memberIds).map(mid => {
      const member = reportMembers.find(m => m.id === mid);
      return member ? (member.name + ' ' +member.surname) : null;
   }).filter(Boolean);
    return memberNames.join(", ") || "-";
  }

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Notikumu grupu pārskats</h2>
      {reports.map(report => {
        const linkedGroups = reportGroups
          .filter(rg => rg.report_id === report.id)
          .map(rg => groups.find(g => g.id === rg.report_group_id)?.name)
          .filter(Boolean);
        return (
          <div key={report.id} className="mb-4 p-4 border rounded shadow">
            <h3 className="font-semibold">{report.report_text}</h3>
            <p>Iekārtas sērijas Nr.: {report.serial}</p>
            <p>Pogas Nr.: {report.button_id}</p>
            <p>Maks vecums: {minutesLabel(report.max_age/60.0)}</p>
            <p>Maks biežums: {minutesLabel(report.max_frequency/60.0)}</p>
            <p>Grupas: {linkedGroups.join(", ") || "-"}</p>
            <p>Personas: {getReportMembers(report.id)}</p>
          </div>
        );
      })}
    </div>
  );
}
